export class Base
{
	protected _mtmAuto=null;
	protected _guid=null;
	protected _lastDataTime=null;
	protected _parentObj=null;
	protected _eventObj=null;
	protected _eventMethod=null;
	
	protected terminate() :any {}; //client must have, make interface

	public setAuto(mtmAuto)
	{
		this._mtmAuto	= mtmAuto;
		return this;
	}
	public getAuto()
	{
		return this._mtmAuto;
	}
	public getGuid()
	{
		if (this._guid === null) {
			this._guid	= this.getAuto().get("utilities").getGuids().getV4().get(false);
		}
		return this._guid;
	}
	public setParent(obj)
	{
		this._parentObj	= obj;
		return this;
	}
	public getParent()
	{
		return this._parentObj;
	}
	public setEventCb(obj=null, method=null)
	{
		if (typeof obj == "object" && typeof method == "string") {
			this._eventObj		= obj;
			this._eventMethod	= method;
		}
		return this;
	}
	public async newEvent(data)
	{
	
		if (this._eventObj !== null) {
			var rData	= this._eventObj[this._eventMethod](data);
			if (typeof rData["then"] == "function") {
				//return is a promise
				return await rData;
			} else {
				//data not promise
				return rData;
			}
		} else {
			this.terminate();
			throw this.getAuto().newException("No event callback set");
		}
	}
	public getLastDataTime()
	{
		//last time someone asked for our location on the network
		return this._lastDataTime;
	}
	public getData()
	{
		//this sync's location on the network
		this._lastDataTime	= this.getAuto().get("utilities").getTime().getMicroEpoch(true);
		var rObj			= {};
		rObj["peerId"]		= this.getParent().getRouteGuid();
		rObj["syncId"]		= this.getGuid();
		return rObj;
	}
}